module.exports = __webpack_public_path__ + "img/file-type-sheet.eba7d124.svg";